import { observer } from "mobx-react";
import React, { Component } from "react";
import BatterSideFilter from "./options/BatterSideFilter";
import PitcherHandFilter from "./options/PitcherHandFilter";
import DateRangeFilter from "./options/DateRangeFilter";
import HardballFilter from "./options/HardballFilter";
import LastNGameFilter from "./options/LastNGameFilter";
import PitchTypeFilter from "./options/PitchTypeFilter";
import TimeOfDayFilter from "./options/TimeOfDayFilter";
import VenueFilter from "./options/VenueFilter";
import ZRangeFilter from "./options/ZRangeFilter";
import XRangeFilter from "./options/XRangeFilter";
import FilterGroup from "./FilterGroup";

class PitchCriteria extends Component {
  render() {
    const { store } = this.props;

    return (
      <FilterGroup title="Pitch Criteria" large showChildren={false}>
        <PitchTypeFilter store={store} />
        <HardballFilter
          checked={store.hardballsCheckboxGroup}
          onChangeHandler={store.updateHardballs}
        />
        <VenueFilter
          multi={this.props.multiVenue}
          simpleValue
          name="pitch-criteria-venue-selection"
          value={store.venueIds}
          onChangeHandler={store.updateVenueIds}
        />
        <DateRangeFilter store={store} />
        <LastNGameFilter store={store} />
        <BatterSideFilter
          name="pitch-criteria-batter-side-radio"
          store={store}
        />
        <PitcherHandFilter
          name="pitch-criteria-pitcher-hand-ratio"
          value={store.selectedPitcherHand}
          onChangeHandler={store.updateSelectedPitcherHand}
        />
        <TimeOfDayFilter
          name="pitch-criteria-time-of-day-radio"
          store={store}
        />
        <XRangeFilter store={store} />
        <ZRangeFilter store={store} />
      </FilterGroup>
    );
  }
}

export default observer(PitchCriteria);



// WEBPACK FOOTER //
// ./src/components/filters/PitchCriteria.js